import React from 'react';
import PropTypes from 'prop-types';

import {Skills as ModuleSkills} from 'views/module';

const Skills = (props) => {
  const {clientBackend, clientData, clientRn} = props;

  const skillProps = React.useMemo(() => {
    const primaryRelationship = Object.values(clientData?.relationships ?? {}).find((relationship) => {
      return Number(relationship?.priority) === 1;
    }) || null;
    const relationshipRn = primaryRelationship?.relationshipRn || null;
    const email = primaryRelationship?.contacts?.find((contact) => {
      return contact?.type === 'Email';
    })?.detail || '';
    const sms = primaryRelationship?.contacts?.find((contact) => {
      return contact?.type === 'Phone';
    })?.detail || '';

    return {
      communicationTarget: {
        email,
        sms,
        sendEmail: async (emailData, onSuccess, onError=()=>undefined) => {
          if (!relationshipRn) {
            onError();
            return null;
          }

          return clientBackend.messages.sendEmail(relationshipRn, emailData, onSuccess, onError);
        },
        sendSms: async (smsData, requester, onSuccess, onError=()=>undefined) => {
          if (!relationshipRn) {
            onError();
            return null;
          }

          return clientBackend.messages.sendSms(
              relationshipRn,
              smsData.message,
              requester?.email,
              smsData.from,
              onSuccess,
              onError,
          );
        },
      },
      resources: [
        {type: 'CLIENT', rn: clientRn},
      ],
    };
  }, [clientBackend, clientData, clientRn]);

  return (
    <ModuleSkills
      {...skillProps}
    />
  );
};

Skills.propTypes = {
  clientBackend: PropTypes.object.isRequired,
  clientData: PropTypes.object.isRequired,
  clientRn: PropTypes.string.isRequired,
};

export default React.memo(Skills);
